import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import {  Usuario } from '../../utils/interfaces';

export interface UsuarioFilter {
  nome?: string;
  cpf?: string;
  usuario?: string;
  data_inicial?: string;
  data_final?: string;
}

export interface useUsuarioProps {
  filter?: UsuarioFilter;
}

interface GetUsuarioResponse {
  usuarios: Usuario[];
}
async function getUsuario({ filter }: useUsuarioProps): Promise<GetUsuarioResponse> {
  const response = await api
    .get('usuario', {
      params: {
        ...filter,
      },
    })
    .then((res) => res.data);

  const usuarios: Usuario[] = response.data;

  return {
    usuarios,
  };
}

export function useUsuarios({ filter }: useUsuarioProps) {
  return useQuery({
    queryKey: ['usuarios-lista', { filter }],
    queryFn: () => getUsuario({ filter }),
    retry: false,
    refetchOnWindowFocus: false, // Only refetch when the window is not in focus
  });
}